import React from 'react';
import './progressBar.scss'
import PropTypes from "prop-types";

const ProgressBar = ({value, color, max, className=""}) => {
    return <div className={`Suc-progressbar ${className}`}>
        <div className="Suc-filled-value" style={{width: value/max*100 + '%', backgroundColor: color}} />
    </div>
}

ProgressBar.propTypes = {
  /** Custom className */
  className: PropTypes.string,
  /** Value filled out of max */
  value: PropTypes.number,
  /** Maximum number */
  max: PropTypes.number,
  /** custom color (valid css) */
  color: PropTypes.string,
}

ProgressBar.defaultProps = {
  color: '#2D6BCC',
  className: '',
  max: 100,
  value:0
}

export default ProgressBar;
